// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1-Z5n","rootSmall":"AddTileButton_rootSmall__1Z2N-"};